<section cubeTranslate cubeNotificationHandler cubeLayoutModeHandler>
  <main>
    <router-outlet></router-outlet>
  </main>
</section>
